import { useCallback } from "react";
import { useNotify } from "react-admin";

import { useImageUpload } from "./useImageUpload";

export type WithAvatar = {
  avatar?: {
    rawFile?: File;
  };
};

export type WithAvatarId = {
  avatarId?: string;
};

export const useImageUploadHandler = <T extends WithAvatar>() => {
  const notify = useNotify();
  const { uploadImage } = useImageUpload();

  const handleImageUpload = useCallback(
    async (data: T): Promise<Omit<T, "avatar"> & WithAvatarId> => {
      const { avatar, ...restData } = data;

      if (avatar?.rawFile) {
        try {
          const avatarId = await uploadImage(avatar.rawFile);
          return { ...restData, avatarId } as Omit<T, "avatar"> & WithAvatarId;
        } catch (error) {
          console.error("Error uploading image:", error);
          notify("Error uploading image", { type: "error" });
          throw error;
        }
      }
      return restData as Omit<T, "avatar">;
    },
    [notify, uploadImage]
  );

  return { handleImageUpload };
};
